import {
	Button, ButtonAppearance, CheckmarkDoubleIcon, LoaderBars,
} from '@aleph/shared-components';
import useNotificationsPolling
	from 'wb-reddit/app/routes/superGrid/actionRow/notifications/hooks/useNotificationsPolling';
import { useMutation } from '@apollo/client';
import { MarkNotificationsAsReadDocument, RedditNotificationsDocument } from 'wb-reddit/graphql/generated';
import { useTranslation } from 'react-i18next';

const ReadAllNotifsButton = () => {
	const { t } = useTranslation();
	const { notifications } = useNotificationsPolling();
	const [markAsRead, { loading }] = useMutation(MarkNotificationsAsReadDocument, {
		refetchQueries: [RedditNotificationsDocument],
	});

	const onMarkAllAsRead = async () => {
		await markAsRead({
			variables: {
				notificationIds: notifications.map(notification => notification.id),
			},
		});
	};

	if (!notifications.length) {
		return null;
	}

	return (
		<Button
			onClick={onMarkAllAsRead}
			className="text-blue-500 text-base flex items-center gap-[8px] pl-4 pr-5"
			leftNode={
				loading ? <LoaderBars
					width={16}
					height={16}
					className="animate-spin"
				/> : <CheckmarkDoubleIcon
					width={16}
					height={16}
				/>
			}
			title={t('sc: notification.mark_all', 'Mark all as read')}
			appearance={ButtonAppearance.GHOST}
		/>
	);
};

export default ReadAllNotifsButton;
